"use client";

import type { FC } from "react";

import HeroBanner from "./hero-banner/HeroBanner";

import type { trialHeroBannerInputs } from "./TrialHeroBanner.builder";

import heroContainerStyles from "../HeroBannerContainer/HeroBannerContainer.module.scss";

export type TrialHeroBannerProps = BuilderComponentProps<typeof trialHeroBannerInputs>;

export const TrialHeroBanner: FC<TrialHeroBannerProps> = ({ data, breadcrumbsSpacing = false }) => {
  return (
    <div className={heroContainerStyles.fullHeightContainer}>
      <HeroBanner {...data} breadcrumbsSpacing={breadcrumbsSpacing} />
    </div>
  );
};

export default TrialHeroBanner;
